// import 'devextreme/dist/css/dx.common.css';
// import 'devextreme/dist/css/dx.light.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './plugins/vuex'
import vuetify from './plugins/vuetify'
import EasyPlanClient from './utils/EasyPlanClient'

import '@/styles/styles.scss'

Vue.config.productionTip = false
if(localStorage.userToken!=undefined && localStorage.userToken!="null")
{ 
    EasyPlanClient.SetJWT(localStorage.userToken);
 }
var vm=new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

 